import {AfterViewInit, Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {AccountCreationService} from '../../../services/account-creation.service';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-roles-modal',
  templateUrl: './roles-modal.component.html',
  styleUrls: ['../creation-modal.component.less']
})
export class RolesModalComponent implements OnInit, AfterViewInit {
  @ViewChild('rolesSelectionList', { static: true }) list: ElementRef;
  @ViewChild('rolesSelectionList', { static: true }) modal: ElementRef;
  @ViewChildren('rolesCheckbox') rolesCheckbox: QueryList<ElementRef>;
  fixedRoles = [];
  selectedRoles = [];
  flagOptionsRoles = new Subject();
  allChecked = false;
  selectedFocus = true;

  constructor(private modalRef: BsModalRef,
              private accountCreationService: AccountCreationService) {
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode === 9 && this.selectedFocus) {
      (this.list.nativeElement.firstElementChild as HTMLElement).focus();
      this.selectedFocus = false;

    }
    if (event.keyCode === 27) {
      this.cancelModal();
    }
}
  ngOnInit() {
    this.selectedRoles = this.accountCreationService.getChosenRoles();
    this.fixedRoles = this.accountCreationService.getCombinedRoles();
    this.allChecked = this.checkIfAllSelected();
    this.checkSelectedRoles();
  }

  ngAfterViewInit() {
    this.list.nativeElement.addEventListener('keydown', this.onKeyDown.bind(this));

  }

  private onKeyDown(evt) {
    let currentActive = document.activeElement;
    // tslint:disable-next-line:typeof-compare
    if (currentActive.nodeName === 'INPUT') {
      currentActive = currentActive.parentElement;
    }
    switch (evt.keyCode) {
      case 38: // up
        (currentActive.previousElementSibling as HTMLElement).focus();
        evt.preventDefault();
        break;
      case 40: // down
        (currentActive.nextElementSibling as HTMLElement).focus();
        evt.preventDefault();
        break;
      case 32: // space
        const checkbox = (currentActive.firstElementChild as HTMLInputElement);
        if (checkbox.id === 'roles-select-all') {
          this.toggleSelectAllRolesOnPage();
        } else {
          const rolesIndex = +checkbox.id.replace('role', '');
          this.checkItem(this.fixedRoles[rolesIndex], !checkbox.checked);
        }
        evt.preventDefault();
        break;
    }
  }

  private checkSelectedRoles() {
    this.fixedRoles = this.fixedRoles.map((role) => {
      let roleItem: any = {};
      roleItem.role = role;
      roleItem.checked = this.selectedRoles.includes(role);
      return roleItem;
    });
  }

  private checkIfAllSelected() {
    return this.selectedRoles.length >= this.fixedRoles.map(item  => item.checked === true).length;
  }

  private checkItem(item: any, isSelected: boolean) {
    item.checked = isSelected;
    if (isSelected) {
      this.selectedRoles.push(item.role);
      this.allChecked = this.checkIfAllSelected();
    } else {
      let index = this.selectedRoles.indexOf(item.role);
      this.selectedRoles.splice(index, 1);
      this.allChecked = false;
    }
  }

  public onChange(item: any, isSelected) {
    this.checkItem(item, isSelected.checked);
  }

  public toggleSelectAllRolesOnPage() {
    if (!this.allChecked) {
      this.fixedRoles = this.fixedRoles.map(item => {
        item.checked = true;
        return item;
      });
      this.selectedRoles = this.fixedRoles.map(item =>  item.role);
    } else {
      this.selectedRoles = [];
      this.fixedRoles.map(item => {
        item.checked = false;
        return item;
      });
    }
    this.allChecked = !this.allChecked;
  }

  public doneModal() {
    setTimeout(() => {
      document.getElementById('roles-open-modal-btn').focus();
    }, 1000);
    this.accountCreationService.setChosenRolesFromModal(this.selectedRoles);
    return this.modalRef.hide();
  }

  public cancelModal() {
    setTimeout(() => {
      document.getElementById('roles-open-modal-btn').focus();
    }, 1000);
    return this.modalRef.hide();
  }

}
